var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-issue-status-button",on:{"click":_vm.markAsFixedUnfixedIssue}},[_vm._v(" "+_vm._s(_vm.$t(_vm.markButtonCaption))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }